(() => {
  const homes = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const clamp = value => Math.max(0, Math.min(1, value));
  const update = () => {
    frame = 0;
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const headerHeight = document.querySelector('[data-gml-topbar]')?.offsetHeight || 80;
    let darkHero = false;
    for (const [home, parts] of homes) {
      const rect = parts.cinema.getBoundingClientRect();
      const heroRect = parts.hero.getBoundingClientRect();
      const heroHeight = Math.max(1, parts.hero.offsetHeight);
      const distance = Math.max(0, -rect.top);
      const start = heroHeight * .28;
      const end = Math.max(start + 1, Math.min(heroHeight * .9, rect.height - viewport * 1.12));
      const progress = clamp((distance - start) / (end - start));
      const easedProgress = motion.matches ? progress : progress * progress * (3 - 2 * progress);
      const wash = .58 * easedProgress;
      parts.media.style.setProperty('--gml-crystal-wash', wash.toFixed(4));
      home.dataset.gmlCrystalReady = 'true';
      if (heroRect.top <= headerHeight && heroRect.bottom > headerHeight && easedProgress < .55) darkHero = true;
    }
    if (darkHero) document.body.dataset.gmlCrystalHero = 'dark';
    else delete document.body.dataset.gmlCrystalHero;
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const init = (scope = document) => {
    const found = [...scope.querySelectorAll('[data-gml-home]')];
    if (scope.matches?.('[data-gml-home]')) found.unshift(scope);
    for (const home of found) {
      if (homes.has(home)) continue;
      const cinema = home.querySelector('[data-gml-home-cinema]');
      const hero = home.querySelector('.gml-home__hero');
      const media = home.querySelector('.gml-home__media');
      if (!cinema || !hero || !media) continue;
      homes.set(home, { cinema, hero, media });
      resize?.observe(cinema);
      resize?.observe(hero);
    }
    schedule();
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  motion.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [home, parts] of homes) {
      if (event.target === home || event.target.contains(home)) {
        resize?.unobserve(parts.cinema);
        resize?.unobserve(parts.hero);
        homes.delete(home);
        delete home.dataset.gmlCrystalReady;
      }
    }
    schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
